import { Beacon, UpdateActiveStep } from '@/components/forms/FormContext';
import { StepMap, steps } from '../../constants';

export const buyingDecisionStepGraph: Beacon<StepMap> = {
	[steps.BuyingDecision]: [steps.Message],
};

export const handleNext: UpdateActiveStep = <StepMap>(): StepMap => {
	// What ever logic is needed to determine the next step
	return steps.Message as StepMap;
};
